import {
  IFlowSelector as IContentfulFlowSelector,
  IFlowOption as IContentfulFlowOption,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import {
  FlowSelector,
  IProps as IFlowSelectorProps,
  IFlowOptionProps,
} from 'marketing-site/src/library/components/FlowSelector'
import { localiseURL } from 'marketing-site/src/library/utils/localiseURL'
import React from 'react'

export const ContentfulFlowSelector = (
  flowSelector: IContentfulFlowSelector,
): React.ReactElement => (
  <EntryMarker entry={flowSelector}>
    {() => <FlowSelector {...transformFlowSelector(flowSelector)} />}
  </EntryMarker>
)

export function transformFlowOptions({ fields, sys }: IContentfulFlowOption): IFlowOptionProps {
  const { label } = fields
  const { locale = '' } = sys
  const url = localiseURL(fields.url, locale)

  return {
    label,
    url,
  }
}

export function transformFlowSelector({ fields }: IContentfulFlowSelector): IFlowSelectorProps {
  return {
    ...fields,
    flowOptions: fields.flowOptions.map((option) => transformFlowOptions(option)),
  }
}
